export const calcTotalDemand = (orders) =>
  orders.reduce((sum, o) => sum + (Array.isArray(o.Demand) ? o.Demand[0] : 1), 0);

export const calcInitialReloadCapacity = (currentCapacity, totalDemand) =>
  currentCapacity.map((c) =>
    totalDemand > 0
      ? Math.min(c, Math.max(1, Math.ceil(totalDemand / 2)))
      : Math.max(1, Math.ceil(c / 2)),
  );

export const calcReloadCapacity = (currentCapacity, totalDemand, numReloads) =>
  currentCapacity.map((c) => Math.min(c, Math.max(1, Math.ceil(totalDemand / (numReloads + 1)))));

export const applyCapacityToFirstVehicle = (vehicles, reloadCapacity) =>
  vehicles.map((v, i) => (i === 0 ? { ...v, amount: 1, capacity: reloadCapacity } : v));
